export const indicators = {
  gdhi: "Monitor de salud digital mundial",
  indicatorGuide: "Guía de indicadores",
  paragraph1:
    "El <a class='link-blue' href='http://digitalhealthmonitor.org' target='_blank'>Monitor de salud digital mundial (GDHM)</a> es un " +
    "recurso digital interactivo que rastrea, monitorea y evalúa el uso de la tecnología digital para la salud en todos los países. El GDHM " +
    "utiliza siete categorías de indicadores clave para seguir el progreso.",
  indicator: "Indicador",
  selected_indicator: "indicador seleccionado",
};
